import axios from 'axios';
import Cookies from 'js-cookie';
import router from '@/router';
import store from '../store'; 
import { ElMessage,ElMessageBox } from 'element-plus';

// 创建一个 axios 实例
const service = axios.create({
	baseURL: '/', // 所有的请求地址前缀部分
	timeout: 10000, // 请求超时时间毫秒
	withCredentials: true,
	
})

// 添加请求拦截器
service.interceptors.request.use(
	function (config) {
		return config
	},
	function (error) {
		// 对请求错误做些什么
		return Promise.reject(error)
	}
)

// 添加响应拦截器
service.interceptors.response.use(
	function (response) {
		// 2xx 范围内的状态码都会触发该函数。
		// 对响应数据做点什么
		const dataAxios = response.data
		// 这个状态码是和后端约定的
		const code = dataAxios.code
		if (code === 201){
			ElMessageBox.alert(dataAxios.msg, '温馨提示', {
				customClass: 'error-box',
				showConfirmButton: false,
				callback: action => {

				}
			})
			return false
		}else{
			return dataAxios
		}
	},
	function (error) {
		// 超出 2xx 范围的状态码都会触发该函数。
		// 对响应错误做点什么
		ElMessage({
			offset:70,
			message: '请求超时',
			type: 'error'
		})
		return Promise.reject(error)
	}
)
export default service